import React, { useEffect, useRef, useState } from 'react';
import LogoRef from '../../assets/img/logoRef.png';
import SuperSearchList from '../shared/SuperSearch/SuperSearchList';
import isNull from '../../utils/NullChecking';
import AmountFormatter from '../../utils/AmountFormatter';
import FormValidator from '../../utils/FormValidator';
import { enumUtil } from '../../utils/Enum';
import NotificationHandler from '../../utils/NotificationHandler';
import Loader from '../shared/Loader/Loader';
import handleAlphabeticCheck from '../../utils/HandleAlphabetKeys';
import axios from 'axios';
import States, { Countries } from '../../utils/Constants';
import ViewPaidReceipt from './ViewPaidReceipt';
import handleNumericCheck from '../../utils/HandleNumericKeys';
import { useNavigate, useParams } from 'react-router-dom';
import { ServerRequestProtectedOCR } from '../../utils/ServerDataRequest';
import Cookies from "js-cookie";
import isAmountNull from '../../utils/AmountNullChecker';
import { useSelector } from 'react-redux';

const AddCard = () => {
    let Card_Modal = {
        email: '',
        name: '',
        account: '',
        expiry: '',
        SecurityCode: '',
        CountryRegion: 'United States',
        UseSavedCard: false,
        CardlastDigit: null,
        SaveInfo: false,
        amount: '',
        PatientID: null,
        address: '',
        city: '',
        region: '',
        zipCode: '',
    }
    let valModal = {}
    let ValidationModal = {
        EmailVal: '',
        EmailFormatVal: '',
        NameVal: '',
        AccountVal: '',
        AccountLenVal: '',
        ExpiryVal: '',
        SecurityCodeVal: '',
        SecurityCodeLenVal: '',
        CountryRegionVal: '',
    }
    const API_URL_Payment = enumUtil.controller.Propelrpay
    const API_URL = process.env.REACT_APP_API
    const navigate = useNavigate();
    const { paymentId } = useParams();
    const [CardValidationModal, setCardValidationModal] = useState(ValidationModal)
    const [userCard, setUserCard] = useState(false);
    const [showProcedureDetails, setShowProcedureDetails] = useState(false);
    const [showFullPaymentDetails, setShowFullPaymentDetails] = useState(false);
    const [useSavedCard, setUseSavedCard] = useState(userCard ? 'savedCard' : 'newCard');
    const [procedureCodeData, setProcedureCodeData] = useState([]);
    const [fullPatientCPTData, setfullPatientCPTData] = useState([])
    const [otherDetails, setOtherDetails] = useState({});
    const [cardDetails, setCardDetails] = useState(Card_Modal);
    const [is, setIs] = useState(true);
    const [saveCardDetails, setSaveCardDetails] = useState({
        // CountryRegion: 'United States'
    });
    const [isLoading, setIsLoading] = useState(false);
    const [showPaymentReceipt, setShowPaymentReceipt] = useState(false);
    const [paymentResponse, setPaymentResponse] = useState(null);
    let RealToken = Cookies.get('cookedToken')
    const Reloader = localStorage.getItem('PatientPaymentDetails');
    const handleCardChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        // Handle expiration date formatting
        if (name === 'expiry') {
            value = formatExpiryDate(value);
        }
        let modal = { ...cardDetails };
        modal[name] = value;
        setCardDetails(modal)
        for (var property in Card_Modal) {
            if (name === property) {
                saveCardDetails[name] = value
            }
        }
        setSaveCardDetails(saveCardDetails)
    }
    // Expiry date formatting function
    const formatExpiryDate = (input) => {
        // Remove any non-digit characters
        let value = input.replace(/\D/g, '');

        // Format as MM/YY
        if (value.length >= 2) {
            // Get month and validate
            let month = value.substring(0, 2);
            if (parseInt(month) > 12) {
                month = '12';
            } else if (parseInt(month) < 1 && month.length === 2) {
                month = '01';
            }

            // Add slash after month
            if (value.length > 2) {
                let year = value.substring(2, 4);
                value = month + '/' + year;
            } else {
                value = month;
            }
        }

        // Limit to MM/YY format (5 characters total)
        return value.substring(0, 5);
    };
    const handleSelctData = (selectedData, name, type) => {
        setIs(true)
        let modal = { ...cardDetails };
        let saveModal = { ...saveCardDetails }
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + "";

        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + "";
        } else {
            modal[name] = ''
            saveModal[name] = ''
        }
        setCardDetails(modal)
        setSaveCardDetails(saveModal)
        return selectedData
    }
    const CardValidation = async () => {
        if (userCard === false) {
            let ValidationModal = {
                NameVal: FormValidator(
                    cardDetails.name,
                    enumUtil.enumValidationType.Required,
                    'Name',
                ),
                EmailVal: FormValidator(
                    cardDetails.email,
                    enumUtil.enumValidationType.Required,
                    'Email',
                ),
                EmailFormatVal: FormValidator(
                    cardDetails.email,
                    enumUtil.enumValidationType.Email,
                    'Email',
                ),
                ExpiryVal: FormValidator(
                    cardDetails.expiry,
                    enumUtil.enumValidationType.Required,
                    'Expiration Date',
                ),
                AccountVal: FormValidator(
                    cardDetails.account,
                    enumUtil.enumValidationType.Required,
                    'Account Number',
                ),
                // AccountLenVal: FormValidator(
                //     cardDetails.account,
                //     enumUtil.enumValidationType.Length,
                //     'Account Number',
                //     10  // lenght validation for account number, adjust as needed
                // ),
                SecurityCodeVal: FormValidator(
                    cardDetails.SecurityCode,
                    enumUtil.enumValidationType.Required,
                    'Security Code'
                ),
                SecurityCodeLenVal: FormValidator(
                    cardDetails.SecurityCode,
                    enumUtil.enumValidationType.Length,
                    'Security Code',
                    3
                ),
                CountryRegionVal: FormValidator(
                    cardDetails.CountryRegion,
                    enumUtil.enumValidationType.Required,
                    'Country/Region'
                ),
            }
            await setCardValidationModal(ValidationModal)
            valModal = ValidationModal
        }
    }
    const getPrintStatementData = async () => {
        try {
            const response = await axios.get(
                `${API_URL}Pay/${paymentId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error(
                "GET Payment API Error:",
                error.response?.data || error.message
            );
            throw error;
        }
    }
    const [paymentLink, setPaymentLink] = useState('')
    // fts.cardconnect.com
    // fts-uat.cardconnect.com
    useEffect(() => {
        if (paymentId) {
            const fetchData = async () => {
                try {
                    const data = await getPrintStatementData();
                    setOtherDetails(data);
                    setProcedureCodeData(data?.requestdata?.procedureItems)
                    setfullPatientCPTData(data?.requestdata?.allprocedureItems)
                    setPaymentLink(data?.requestdata?.paymentGateWayTokenizerURL)
                    if (!isNull(data?.cardlastDigit)) {
                        setUserCard(true);
                        setUseSavedCard('savedCard');
                    } else {
                        setUserCard(false);
                        setUseSavedCard('newCard');
                    }
                } catch (err) {
                    console.log("Error fetching payment data");
                }
            };
            fetchData()
        } else {
            const paymentDetails = localStorage.getItem('PatientPaymentDetails');
            if (!isNull(paymentDetails)) {
                localStorage.removeItem('PatientPaymentDetails');
                const data = JSON.parse(paymentDetails);
                setPaymentLink(data.paymentGateWayTokenizerURL)
                setOtherDetails(data);
                setProcedureCodeData(data?.requestdata?.procedureItems)
                if (!isNull(data?.cardlastDigit)) {
                    setUserCard(true);
                    setUseSavedCard('savedCard');
                } else {
                    setUserCard(false);
                    setUseSavedCard('newCard');
                }
            }
        }
    }, [Reloader])
    const savePrintStatementPayment = async () => {
        // ServerRequestProtectedOCR(API_URL_Payment + "/ProcessStatmentPropelrPay", 'post', paymentData)
        //     .then((response) => {
        //         setIsLoading(false)
        //         setShowPaymentReceipt(true);
        //         setPaymentResponse(response.data);
        //     }).catch((error) => {
        //         setIsLoading(false)
        //         setPaymentResponse(null);
        //         setShowPaymentReceipt(false);
        //         NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        //     })
        // if (!isNull(RealToken)) {
        let paymentData = {
            ...saveCardDetails,
            PatientID: otherDetails?.requestdata?.patientID + "",
            amount: selectedOption === 'statementBalance' ? otherDetails?.requestdata?.amount + "" : otherDetails?.requestdata?.totalAmount + "",
            UseSaveCard: useSavedCard === "savedCard" ? true : false,
            // CardlastDigit:
            //     useSavedCard === "savedCard"
            //         ? otherDetails?.cardlastDigit + ""
            //         : "",
            printStatementsLogsID: otherDetails?.printStatementsLogsID,
            statementNo: otherDetails?.statementNo,
            statementData: otherDetails?.statementData,
            Token: token,
            amountType: selectedOption === 'statementBalance' ? 'Statement Balance' : 'All Balance',
            allprocedureItems: fullPatientCPTData,
            procedureItems: procedureCodeData
        };
        try {
            const response = await axios.post(
                // 'https://acpt.theeasyedi.com/Propelrpay/ProcessStatmentPropelrPay', dawood
                otherDetails?.checkoutUrl,
                paymentData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        // "Authorization": `Bearer ${RealToken}`
                    },
                }
            );
            setIsLoading(false)
            // setShowPaymentReceipt(true);
            const PaymentsID = response?.data?.practiceData?.patientPaymentsID; // adjust based on API response
            if (PaymentsID) {
                navigate(`/ViewPaidReceipt/${PaymentsID}`);
            }
            setPaymentResponse(response.data);
            localStorage.removeItem('PatientPaymentDetails');
            return response.data;
        } catch (error) {
            localStorage.removeItem('PatientPaymentDetails');
            setIsLoading(false)
            setPaymentResponse(null);
            setShowPaymentReceipt(false);
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            throw error;
        }
        // } else {
        //     NotificationHandler('Session expired, please refresh', enumUtil.enumtoaster.error) // ✅ don't fail silently
        // }
    }
    const handlePayNow = async () => {
        // await CardValidation();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        // if (validation) {
        //     NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
        //     return
        // } else {
        // let paymentData = {
        //     ...saveCardDetails,
        //     PatientID: otherDetails?.requestdata?.patientID + "",
        //     amount: otherDetails?.requestdata?.amount + "",
        //     UseSaveCard: useSavedCard === 'savedCard' ? 'true' : 'false',
        //     CardlastDigit: useSavedCard === 'savedCard' ? otherDetails?.cardlastDigit + "" : '',
        // }
        // debugger
        if (selectedOption === 'statementBalance' && isAmountNull(otherDetails?.requestdata?.amount)) {
            return
        }
        if (selectedOption === 'fullBalance' && isAmountNull(otherDetails?.requestdata?.totalAmount)) {
            return
        }
        if (isNull(token) && useSavedCard === 'newCard') {
            NotificationHandler('Card information is missing', enumUtil.enumtoaster.error)
            return
        } else {
            if (!isNull(paymentId)) {
                setIsLoading(true)
                savePrintStatementPayment()
            } else {
                try {
                    setIsLoading(true)
                    let paymentData = {
                        ...saveCardDetails,
                        PatientID: otherDetails?.requestdata?.patientID + "",
                        amount: otherDetails?.requestdata?.amount + "",
                        Token: token,
                        UseSaveCard: useSavedCard === "savedCard" ? true : false,
                        // CardlastDigit:
                        //     useSavedCard === "savedCard"
                        //         ? otherDetails?.cardlastDigit + ""
                        //         : "",
                    };
                    const response = await axios.post(
                        otherDetails?.checkoutUrl,
                        paymentData,
                        {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    setIsLoading(false)
                    // setShowPaymentReceipt(true);
                    setPaymentResponse(response.data);
                    window.opener.postMessage(
                        {
                            paymentId: response?.data?.practiceData?.session_id || '123456',
                            status: "Success",
                            printStatementsLogsID: otherDetails?.printStatementsLogsID ? otherDetails?.printStatementsLogsID : null,
                        },
                        window.location.origin
                    );
                    localStorage.removeItem('PatientPaymentDetails');
                    window.close();
                    return response.data;
                } catch (error) {
                    setIsLoading(false)
                    setShowPaymentReceipt(false);
                    setPaymentResponse(null);
                    window.opener.postMessage(
                        {
                            paymentId: null,
                            status: "Failed",
                            printStatementsLogsID: '',
                            error: error.response.data
                        },
                        window.location.origin
                    );
                    localStorage.removeItem('PatientPaymentDetails');
                    window.close();
                    console.error("Payment API Error:", error.response?.data || error.message);
                    throw error;
                }
            }
        }

        // }
    }
    // ifrmae code 
    const [token, setToken] = useState('');

    const generateIframeCss = () => {
        const cssObject = {
            body: {
                margin: '0',
                padding: '0',
                fontFamily: 'Poppins, sans-serif'
            },
            input: {
                appearance: 'auto',
                border: '0.5px solid #D8D8D8',
                borderRadius: '5px',
                color: '#434343',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '12px',
                fontWeight: '400',
                height: '36px',
                padding: '2px 7px',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                width: '100%',
                display: 'block',
                marginBottom: '10px'
            },
            'input:focus': {
                boxShadow: 'none',
                borderColor: 'var(--orangeBright)',
                outline: 'none',
                backgroundColor: '#fff'
            },
            'input + br': {
                display: 'none'
            },
            select: {
                appearance: 'auto',
                border: '0.5px solid #D8D8D8',
                borderRadius: '5px',
                color: '#434343',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '12px',
                fontWeight: '400',
                height: '36px',
                padding: '2px 7px',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                width: 'calc(50% - 15px)',
                marginBottom: '10px',
                backgroundColor: '#fff',
            },
            'select:focus': {
                boxShadow: 'none',
                borderColor: 'var(--orangeBright)',
                outline: 'none'
            },
            '#ccexpiryyear': {
                marginLeft: '12px'
            },
            label: {
                fontSize: '13px',
                color: '#000000',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: '400',
                marginBottom: '3px'
            }
        };

        let cssString = '';
        for (const selector in cssObject) {
            cssString += selector + '{';
            for (const prop in cssObject[selector]) {
                const cssProp = prop.replace(/([A-Z])/g, '-$1').toLowerCase();
                cssString += cssProp + ':' + cssObject[selector][prop] + ';';
            }
            cssString += '}';
        }
        return encodeURIComponent(cssString);
    };
    const iframeUrl = `${paymentLink}?useexpiry=true&invalidexpiryevent=true&usecvv=true&invalidcvvevent=true&cardinputmaxlength=19&cardnumbernumericonly=true&formatinput=true&sendcardtypingevent=true&css=${generateIframeCss()}`;

    const [tokenizing, setTokenizing] = useState(false)
    useEffect(() => {
        if (!paymentLink) return; // don't attach until ready
        // Listener for messages from iframe
        // debugger
        const handleMessage = (event) => {
            // if (!event.origin.includes(paymentLink)) return;
            // Only accept messages from CardPointe
            const baseOrigin = paymentLink.startsWith('http')
                ? new URL(paymentLink).origin
                : `https://${paymentLink}`;

            if (!event.origin.includes(baseOrigin)) return; // ✅ guard, not return UR

            try {
                const data = JSON.parse(event.data);
                if (data.cardTyping === true) {
                    setTokenizing(true);  // show loader
                }
                if (data.message) {
                    setToken(data.message);
                    setTokenizing(false); // hide loadercardTyping
                } else {
                    // setToken('')
                    // setTokenizing(false); // hide loader
                }
                // typing completed or timed out
                if (data.cardTyping === false) {
                    setTokenizing(false);
                }
            } catch (err) {
                console.error("Failed to parse token message", err);
            }
        };

        window.addEventListener("message", handleMessage, false);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [paymentLink]);
    // console.log(tokenizing);

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     if (!token) {
    //         alert("Token not generated yet!");
    //         return;
    //     }

    //     // For now, just log token
    //     console.log("Ready to send token to backend:", token);
    //     alert("Token generated: " + token);
    // };
    const [selectedOption, setSelectedOption] = useState('statementBalance');
    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <>
            {isLoading ? <Loader /> : null}
            {procedureCodeData.length > 0 && showPaymentReceipt === false ?
                <div className="ar_add_payment_detail_screen d-flex flex-column gap-20">
                    <div className="practice_header d-flex align-items-center justify-content-between">
                        {(!isNull(otherDetails?.practiceDate?.practiceLogo)) ?
                            <img src={otherDetails?.practiceDate?.practiceLogo} alt="" style={{ maxHeight: '55px', maxWidth: '100px' }} className="w-max-content" crossOrigin="anonymous" />
                            :
                            <div className="d-flex align-items-center gap-1">
                                <i className="icon-no-image"></i>
                                <p className="text fs-10 ar-light-color">Practice Logo</p>
                            </div>
                        }

                        <div className="d-flex flex-column">
                            <p className="heading fs-16 text-black">{otherDetails?.practiceDate?.practiceName}</p>
                            <p className="text clr-363C45">{otherDetails?.practiceDate?.practiceAddress}</p>
                            {/* <p className="text clr-363C45">{otherDetails?.practiceDate?.email ? otherDetails?.practiceDate?.email + ' | ' : null}  {otherDetails?.practiceDate?.practiceNo}</p> */}

                            <p className="text clr-363C45">
                                {otherDetails?.practiceDate?.practicePaymentEmail ?
                                    otherDetails?.practiceDate?.practicePaymentEmail + " | " : otherDetails?.practiceDate?.email ?
                                        otherDetails?.practiceDate?.email + " | " : ''}
                                {otherDetails?.practiceDate?.statementPhoneNo ?
                                    otherDetails?.practiceDate?.statementPhoneNo : otherDetails?.practiceDate?.practiceNo ?
                                        otherDetails?.practiceDate?.practiceNo : ''}
                            </p>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div className="d-flex flex-column gap-20 add-payment-detail" style={{ maxWidth: "510px" }}>
                            <div className="d-flex flex-column gap-6">
                                <p className="heading fs-25 balck-5-clr">Add Payment Details</p>
                                <p className="text fs-13 balck-5-clr">Enter your card details below to complete your payment securely.</p>
                            </div>

                            {otherDetails?.practiceDate?.gatewayFeesOnPatient === 'true' ?
                                <div className="ar-alert d-flex  gap-10 mb-0 ">
                                    <i className="icon-alert mt-1"></i>
                                    <p className="text fs-11">A processing fee may apply to payments made through the payment gateway in accordance with practice policy, when applicable.</p>
                                </div> : null}
                            {!isNull(paymentId) ?
                                <div className="payment-detail-box d-flex flex-column gap-2 p-2 w-100">
                                    <div className="d-flex flex-column gap-10">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center gap-6 ar_radio-btn">
                                                <input
                                                    type='radio'
                                                    id='statementBalance'
                                                    name='statementBalance'
                                                    checked={selectedOption === 'statementBalance'}
                                                    onChange={() => handleOptionChange('statementBalance')}
                                                />
                                                <p className='text fs-13 ar-orange-text'>Pay Statement Balance (<AmountFormatter amount={otherDetails?.requestdata?.amount} />)</p>
                                            </div>
                                            <p className='text font-m text-decoration-underline cursor-pointer' onClick={() => setShowProcedureDetails(!showProcedureDetails)}>
                                                {showProcedureDetails ? 'Hide Details' : 'View Details'}
                                            </p>
                                        </div>
                                        {showProcedureDetails &&
                                            <div className="d-flex flex-column gap-6">
                                                {procedureCodeData.length > 0 ? procedureCodeData.map((item, index) => (
                                                    <div className="d-flex align-items-center justify-content-between gap-10">
                                                        <div className="d-flex align-items-center gap-1">
                                                            <p className="heading text-black">{item.name.split(' ')[0]}</p>
                                                            <p className="text text-black singleLine-ellispis">{item.name.split(' ').slice(1).join(' ')}</p>
                                                        </div>
                                                        <p className="text text-black"><AmountFormatter amount={item.unitAmount} /></p>
                                                    </div>
                                                )) : <p className="text text-black">No procedure details available.</p>
                                                }
                                            </div>
                                        }
                                    </div>
                                    <div className="d-flex flex-column gap-10">
                                        {otherDetails?.requestdata?.amount === otherDetails?.requestdata?.totalAmount ? null :
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-6 ar_radio-btn">
                                                    <input
                                                        type='radio'
                                                        id='fullBalance'
                                                        name='fullBalance'
                                                        checked={selectedOption === 'fullBalance'}
                                                        onChange={() => handleOptionChange('fullBalance')}
                                                    />
                                                    <p className='text fs-13 ar-orange-text'>Pay Full Balance (<AmountFormatter amount={otherDetails?.requestdata?.totalAmount} />)</p>
                                                </div>
                                                <p className='text font-m text-decoration-underline cursor-pointer' onClick={() => setShowFullPaymentDetails(!showFullPaymentDetails)}>
                                                    {showFullPaymentDetails ? 'Hide Details' : 'View Details'}
                                                </p>
                                            </div>
                                        }
                                        {showFullPaymentDetails &&
                                            <div className="d-flex flex-column gap-6">
                                                {fullPatientCPTData.length > 0 ? fullPatientCPTData.map((item, index) => (
                                                    <div className="d-flex align-items-center justify-content-between gap-10">
                                                        <div className="d-flex align-items-center gap-1">
                                                            <p className="heading text-black">{item.name.split(' ')[0]}</p>
                                                            <p className="text text-black singleLine-ellispis">{item.name.split(' ').slice(1).join(' ')}</p>
                                                        </div>
                                                        <p className="text text-black"><AmountFormatter amount={item.unitAmount} /></p>
                                                    </div>
                                                )) : <p className="text text-black">No procedure details available.</p>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div> :
                                <div className="payment-detail-box d-flex flex-column gap-10 p-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading fs-16 orange-drk '><AmountFormatter amount={otherDetails?.requestdata?.amount} /></p>
                                        <p className='text font-m text-decoration-underline cursor-pointer' onClick={() => setShowProcedureDetails(!showProcedureDetails)}>
                                            {showProcedureDetails ? 'Hide Details' : 'View Details'}
                                        </p>
                                    </div>
                                    {showProcedureDetails &&
                                        <div className="d-flex flex-column gap-6">
                                            {procedureCodeData.length > 0 ? procedureCodeData.map((item, index) => (
                                                <div className="d-flex align-items-center justify-content-between gap-10">
                                                    <div className="d-flex align-items-center gap-1">
                                                        <p className="heading text-black">{item.name.split(' ')[0]}</p>
                                                        <p className="text text-black singleLine-ellispis">{item.name.split(' ').slice(1).join(' ')}</p>
                                                    </div>
                                                    <p className="text text-black"><AmountFormatter amount={item.unitAmount} /></p>
                                                </div>
                                            )) : <p className="text text-black">No procedure details available.</p>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            <div className="d-flex flex-column gap-10">
                                {userCard &&
                                    <div className="d-flex flex-column gap-5">
                                        <label className="ar_radio-btn d-flex align-items-center gap-6">
                                            <input
                                                type="radio"
                                                id="savedCard"
                                                checked={useSavedCard === 'savedCard'}
                                                onChange={() => setUseSavedCard('savedCard')}
                                            />
                                            <p className="text ar-orange-text" htmlFor="savedCard">Use Saved Card</p>
                                        </label>

                                        {useSavedCard === 'savedCard' &&
                                            <div className="save-card-detail p-2 d-flex align-items-center gap-12">
                                                {otherDetails?.cardType.toLowerCase() === 'visa' ?
                                                    <div className=''>
                                                        <img src='/assets/images/Visa.svg' alt="" />
                                                    </div> : otherDetails?.cardType.toLowerCase() === 'mc' ?
                                                        <div className=''>
                                                            <img src='/assets/images/MasterCard.svg' alt="" />
                                                        </div>
                                                        : otherDetails?.cardType.toLowerCase() === 'axp' ?
                                                            <div className=''>
                                                                <img src='/assets/images/AmericanExpress.svg' alt="" />
                                                            </div>
                                                            : ''}
                                                <div className="">
                                                    <p className="heading text-black lh-14">**** **** **** {otherDetails?.cardlastDigit}</p>
                                                    <p className="text text-black lh-14">Exp: {otherDetails?.cardExpiry}</p>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                {userCard ?
                                    <div className="or-content d-flex align-items-center gap-20">
                                        <div className="ar-line w-100"></div>
                                        <p className="text fs-13 ar-light-color text-nowrap">OR</p>
                                        <div className="ar-line w-100"></div>
                                    </div>
                                    : null}
                                <div className="d-flex flex-column gap-5">
                                    {userCard === false ? null :
                                        <label className="ar_radio-btn d-flex align-items-center gap-6">
                                            <input
                                                type="radio"
                                                id="newCard"
                                                checked={useSavedCard === 'newCard'}
                                                onChange={() => setUseSavedCard('newCard')}
                                            />
                                            <p className="text ar-orange-text" htmlFor="newCard">Add New Card</p>
                                        </label>
                                    }
                                    {useSavedCard === 'newCard' &&
                                        // <div className="d-flex flex-column gap-10">
                                        //     <div className={CardValidationModal.EmailVal || CardValidationModal.EmailFormatVal ? "input mb-0 error" : "input mb-0"}>
                                        //         <label className='text-black fs-13'>Email</label>
                                        //         <input type="text"
                                        //             className='form-control'
                                        //             name="email"
                                        //             id="email"
                                        //             value={cardDetails.email}
                                        //             onChange={handleCardChange}
                                        //         />
                                        //         {CardValidationModal.EmailVal}
                                        //         {CardValidationModal.EmailFormatVal}
                                        //     </div>

                                        //     <div className={CardValidationModal.NameVal ? "input mb-0 error" : "input mb-0"}>
                                        //         <label className='text-black fs-13'>Cardholder Name</label>
                                        //         <input type="text"
                                        //             className='form-control'
                                        //             name="name"
                                        //             id="name"
                                        //             value={cardDetails.name}
                                        //             onChange={handleCardChange}
                                        //             onKeyPress={handleAlphabeticCheck}
                                        //         />
                                        //         {CardValidationModal.NameVal}
                                        //     </div>

                                        //     <div className={CardValidationModal.AccountVal ? "input mb-0 error" : "input mb-0"}>
                                        //         <label className='text-black fs-13'>Card Number</label>
                                        //         <div className="position-relative card-number-input">
                                        //             <input type="text"
                                        //                 className='form-control'
                                        //                 name="account"
                                        //                 id="account"
                                        //                 value={cardDetails.account}
                                        //                 onChange={handleCardChange}
                                        //                 maxLength={16}
                                        //                 placeholder="XXXX-XXXX-XXXX-XXXX"
                                        //             />
                                        //             {CardValidationModal.AccountVal}

                                        //             <div className='d-flex gap-5 align-items-center position-absolute translate-middle-y top-50 end-0'>
                                        //                 <img src='/assets/images/MasterCard.svg' alt="" />

                                        //                 <img src='/assets/images/Visa.svg' alt="" />

                                        //                 <img src='/assets/images/AmericanExpress.svg' alt="" />

                                        //                 <img src='/assets/images/UnionPay.svg' alt="" />
                                        //             </div>
                                        //         </div>
                                        //     </div>

                                        //     <div className="d-flex align-items-center gap-12">
                                        //         <div className={CardValidationModal.ExpiryVal ? "input mb-0 w-100 error" : "input mb-0 w-100"}>
                                        //             <label className='text-black fs-13'>Expiration Date</label>
                                        //             <input type="text"
                                        //                 className='form-control'
                                        //                 name="expiry"
                                        //                 id="expiry"
                                        //                 value={cardDetails.expiry}
                                        //                 onChange={handleCardChange}
                                        //                 placeholder='MM/YY'
                                        //             />
                                        //             {CardValidationModal.ExpiryVal}
                                        //         </div>
                                        //         <div className={CardValidationModal.SecurityCodeVal || CardValidationModal.SecurityCodeLenVal ? "input mb-0 w-100 error" : "input mb-0 w-100"}>
                                        //             <label className='text-black fs-13'>Security Code</label>
                                        //             <input type="text"
                                        //                 className='form-control'
                                        //                 name="SecurityCode"
                                        //                 id="SecurityCode"
                                        //                 value={cardDetails.SecurityCode}
                                        //                 onChange={handleCardChange}
                                        //                 maxLength={3}
                                        //                 onKeyPress={handleNumericCheck}
                                        //             />
                                        //             {CardValidationModal.SecurityCodeVal}
                                        //             {CardValidationModal.SecurityCodeLenVal}
                                        //         </div>
                                        //     </div>

                                        //     <div className={CardValidationModal.CountryRegionVal ? "input error" : "input"}>
                                        //         <label className='text-black fs-13'>Country or Region</label>
                                        //         <SuperSearchList
                                        //             type="client"
                                        //             id='CountryRegion'
                                        //             name='CountryRegion'
                                        //             icon={'Simple'}
                                        //             sup_btn='sup_btn-Inp'
                                        //             sup_inp='superSearchVisitInp'
                                        //             searchValue={cardDetails.CountryRegion}
                                        //             data={Countries}
                                        //             onChange={handleCardChange}
                                        //             getSelectedData={handleSelctData}
                                        //             is={is}
                                        //             inputError={CardValidationModal.CountryRegionVal}
                                        //             ScrollOutside={true}
                                        //         />
                                        //         {CardValidationModal.CountryRegionVal}
                                        //     </div>
                                        //     <label className="d-flex align-items-center gap-6 user-select-none">
                                        //         <div className="custom_check_box d-flex">
                                        //             <input
                                        //                 type="checkbox"
                                        //                 className="form-check-input m-0 p-0"
                                        //                 name="SaveInfo"
                                        //                 id="SaveInfo"
                                        //                 checked={cardDetails.SaveInfo}
                                        //                 onChange={(e) => {
                                        //                     let modal = { ...cardDetails };
                                        //                     let saveModal = { ...saveCardDetails }
                                        //                     modal.SaveInfo = e.target.checked;
                                        //                     saveModal.SaveInfo = e.target.checked;
                                        //                     setCardDetails(modal);
                                        //                     setSaveCardDetails(saveModal);
                                        //                 }}
                                        //             />
                                        //         </div>
                                        //         <p className="text text-black fs-13 lh-1">Save my information for future payments.</p>
                                        //     </label>
                                        // </div>
                                        <div >
                                            {paymentLink && (
                                                <iframe
                                                    id="tokenFrame"
                                                    name="tokenFrame"
                                                    // Query params to show expiry + CVV fields
                                                    src={iframeUrl}
                                                    frameBorder="0"
                                                    scrolling="no"
                                                    width="100%"
                                                    height="185"
                                                    title="CardPointe Payment Fields"
                                                ></iframe>
                                            )}
                                            {/* <input type="hidden" name="mytoken" ref={hiddenInputRef} /> */}
                                            {/* Add this right after iframe */}
                                            {/* {useSavedCard === 'newCard' && !token && (
                                                <p className="text fs-12 ar-light-color mt-1">
                                                    <i className="icon-info"></i> Fill in card number, expiry and CVV to continue
                                                </p>
                                            )}
                                            {useSavedCard === 'newCard' && token && (
                                                <p className="text fs-12" style={{ color: 'green' }}>
                                                    ✓ Card details verified
                                                </p>
                                            )} */}
                                            <div className="d-flex flex-column gap-10 mt-10">
                                                <div className={CardValidationModal.NameVal ? "input mb-0 error" : "input mb-0"}>
                                                    <label className='text-black fs-13 font-sans-serif'>Cardholder Name</label>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="name"
                                                        id="name"
                                                        value={cardDetails.name}
                                                        onChange={handleCardChange}
                                                        onKeyPress={handleAlphabeticCheck}
                                                    />
                                                    {CardValidationModal.NameVal}
                                                </div>

                                                <div className="input mb-0">
                                                    <label className='text-black fs-13 font-sans-serif'>Billing Address</label>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="address"
                                                        id="address"
                                                        value={cardDetails.address}
                                                        onChange={handleCardChange}
                                                    />
                                                </div>

                                                <div className="input mb-0 ">
                                                    <label className='text-black fs-13 font-sans-serif'>ZIP Code</label>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="zipCode"
                                                        id="zipCode"
                                                        value={cardDetails.zipCode}
                                                        onChange={handleCardChange}
                                                    />
                                                </div>

                                                <div className="d-flex align-items-center gap-12">
                                                    <div className="input mb-0 w-50">
                                                        <label className='text-black fs-13 font-sans-serif'>City</label>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="city"
                                                            id="city"
                                                            value={cardDetails.city}
                                                            onChange={handleCardChange}
                                                        />
                                                    </div>

                                                    <div className="input w-50">
                                                        <label className='text-black fs-13 font-sans-serif'>State</label>
                                                        <select className="form-control rounded-1"
                                                            id="region"
                                                            name="region"
                                                            value={cardDetails.region}
                                                            onChange={handleCardChange}
                                                        >
                                                            {States.map((state) => (
                                                                <option key={state.value} value={state.value}>
                                                                    {state.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>



                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            name="SaveInfo"
                                                            id="SaveInfo"
                                                            checked={cardDetails.SaveInfo}
                                                            onChange={(e) => {
                                                                let modal = { ...cardDetails };
                                                                let saveModal = { ...saveCardDetails }
                                                                modal.SaveInfo = e.target.checked;
                                                                saveModal.SaveInfo = e.target.checked;
                                                                setCardDetails(modal);
                                                                setSaveCardDetails(saveModal);
                                                            }}
                                                        />
                                                    </div>
                                                    <p className="text text-black fs-13 lh-1">Save my information for future payments.</p>
                                                </label>


                                            </div>



                                        </div>

                                    }
                                </div>
                            </div>
                            {/* // iframe */}
                            {procedureCodeData ?
                                <div className="w-100">
                                    <div className={`btn btn-orange h-100 py-2 lh-normal w-100 rounded d-flex align-items-center justify-content-center
                                      ${selectedOption === 'statementBalance' && isAmountNull(otherDetails?.requestdata?.amount) ? 'disabled' : selectedOption === 'fullBalance' && isAmountNull(otherDetails?.requestdata?.totalAmount) ? 'disabled' : ''}`}
                                        onClick={handlePayNow}>
                                        Pay {selectedOption === 'statementBalance' ? <AmountFormatter amount={otherDetails?.requestdata?.amount} /> :
                                            <AmountFormatter amount={otherDetails?.requestdata?.totalAmount} />
                                        }
                                        {/* {tokenizing ? 'Processing card' : 'Pay Now'} */}
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                    <div className="ar_footer d-flex align-items-center justify-content-center">
                        <p className="heading ar-light-color">{ThemeConfiguration?.configuration?.company?.name},  All Rights Reserved.</p>
                    </div>
                </div>
                : null}
            {showPaymentReceipt ? <ViewPaidReceipt paymentDetails={paymentResponse} procedureCodeData={procedureCodeData} /> : null}
        </>
    )
}

export default AddCard